import * as React from "react";
import isEmpty from "lodash-es/isEmpty";
import { FileType } from "@warda/library-ui/interfaces";
import { ACT_VPORT } from "./reducer";
import InputML from "./InputML";
import PERMS from "../../../constants/permissions";
import hasPerms from "../../../utils/hasPerms";
import { FileAccess, } from "../../../interfaces";
import { AREA } from "../constants";
import isPathMinusOne from "./utils/isPathMinusOne";
import { getPrnt } from "../searchString";
import isPortalConnectedToWebsite from "./utils/isWebsiteConnected";
export const getSelectAction = (selectedTypes, selected, itemType) => {
    if (!selected)
        return [itemType];
    return selectedTypes;
};
var SlcMode;
(function (SlcMode) {
    SlcMode["LEAST_ONE"] = "LEAST_ONE";
    SlcMode["UNSELECT"] = "UNSELECT";
    SlcMode["SINGLE"] = "SINGLE";
    SlcMode["MASSIVE"] = "MASSIVE";
})(SlcMode || (SlcMode = {}));
export var ActionId;
(function (ActionId) {
    ActionId["ACCESS_PORTAL"] = "ACCESS_PORTAL";
    ActionId["ACCESS_FOLDER"] = "ACCESS_FOLDER";
    ActionId["CREATE_PORTAL"] = "CREATE_PORTAL";
    ActionId["CREATE_FOLDER"] = "CREATE_FOLDER";
    ActionId["RENAME_PORTAL"] = "RENAME_PORTAL";
    ActionId["DELETE_PORTAL"] = "DELETE_PORTAL";
    ActionId["RENAME_FOLDER"] = "RENAME_FOLDER";
    ActionId["RENAME_MEDIA"] = "RENAME_MEDIA";
    ActionId["UPLOAD_FOLDER"] = "UPLOAD_FOLDER";
    ActionId["UPLOAD_MEDIA"] = "UPLOAD_MEDIA";
    ActionId["SHAREPAGE_FOLDER"] = "SHAREPAGE_FOLDER";
    ActionId["LINKCDN_MEDIA"] = "LINKCDN_MEDIA";
    ActionId["ATTRSET_MEDIA"] = "ATTRSET_MEDIA";
    ActionId["MOVE"] = "MOVE";
    ActionId["DELETE"] = "DELETE";
    ActionId["DELETE_FOREVER"] = "DELETE_FOREVER";
    ActionId["DELETE_HRCH"] = "DELETE_HRCH";
    ActionId["DOWNLOAD"] = "DOWNLOAD";
    ActionId["RESTORE"] = "RESTORE";
})(ActionId || (ActionId = {}));
const ACTIONS = [
    {
        id: ActionId.ACCESS_PORTAL,
        area: [AREA.PORTALS_LIST],
        icon: "group_add",
        label: "Portal Access",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.PORTAL],
        access: [],
        permis: PERMS.medialibrary_touchpoint_manager,
        action: ACT_VPORT.MODAL_ACCESS,
    },
    {
        id: ActionId.CREATE_PORTAL,
        area: [AREA.PORTALS_LIST],
        icon: "cast_connected",
        label: "Create portal",
        slcMode: SlcMode.UNSELECT,
        slcType: [],
        access: [],
        permis: PERMS.medialibrary_touchpoint_manager,
        action: ACT_VPORT.MODAL_CREATE_PORTAL,
    },
    {
        id: ActionId.CREATE_FOLDER,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "create_new_folder",
        label: "Create folder",
        slcMode: SlcMode.UNSELECT,
        slcType: [],
        access: [FileAccess.ADMIN, FileAccess.WRITE],
        permis: PERMS.medialibrary_manage_content,
        action: ACT_VPORT.MODAL_CREATE_FOLDER,
    },
    {
        id: ActionId.UPLOAD_MEDIA,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "upload_file",
        label: "Upload file",
        slcMode: SlcMode.UNSELECT,
        slcType: [],
        access: [FileAccess.ADMIN, FileAccess.WRITE],
        permis: PERMS.medialibrary_manage_content,
        action: null,
    },
    {
        id: ActionId.UPLOAD_FOLDER,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "drive_folder_upload",
        label: "Upload folder",
        slcMode: SlcMode.UNSELECT,
        slcType: [],
        access: [FileAccess.ADMIN, FileAccess.WRITE],
        permis: PERMS.medialibrary_manage_content,
        action: null,
    },
    {
        id: ActionId.ATTRSET_MEDIA,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "playlist_add_check",
        label: "Apply metadata sets",
        slcMode: SlcMode.LEAST_ONE,
        slcType: [FileType.MEDIA],
        access: [FileAccess.ADMIN],
        permis: PERMS.medialibrary_manage_media_attrs_association,
        action: ACT_VPORT.MODAL_ATTRIBUTE_SET,
    },
    {
        id: ActionId.RENAME_PORTAL,
        area: [AREA.PORTALS_LIST],
        icon: "edit",
        label: "Rename",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.PORTAL],
        access: [FileAccess.ADMIN],
        permis: PERMS.medialibrary_touchpoint_manager,
        action: ACT_VPORT.MODAL_RENAME,
    },
    {
        id: ActionId.DELETE_PORTAL,
        area: [AREA.PORTALS_LIST],
        icon: "delete",
        label: "Delete",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.PORTAL],
        access: [FileAccess.ADMIN],
        permis: PERMS.medialibrary_touchpoint_manager,
        action: ACT_VPORT.MODAL_DELETE,
    },
    {
        id: ActionId.RENAME_FOLDER,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "edit",
        label: "Rename",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.FOLDER],
        access: [FileAccess.ADMIN, FileAccess.WRITE],
        permis: PERMS.medialibrary_manage_content,
        action: ACT_VPORT.MODAL_RENAME,
    },
    {
        id: ActionId.RENAME_MEDIA,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "edit",
        label: "Rename",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.MEDIA],
        access: [FileAccess.ADMIN, FileAccess.WRITE],
        permis: PERMS.medialibrary_manage_content,
        action: ACT_VPORT.MODAL_RENAME,
    },
    {
        id: ActionId.DOWNLOAD,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "file_download",
        label: "Download",
        slcMode: SlcMode.LEAST_ONE,
        slcType: [FileType.MEDIA, FileType.FOLDER],
        access: [],
        permis: PERMS.seecommerce_download,
        action: ACT_VPORT.MODAL_DOWNLOAD,
    },
    {
        id: ActionId.LINKCDN_MEDIA,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "link",
        label: "Publication",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.MEDIA],
        access: [FileAccess.ADMIN],
        permis: PERMS.medialibrary_public_cdn,
        action: ACT_VPORT.MODAL_PUBLICATION,
    },
    {
        id: ActionId.SHAREPAGE_FOLDER,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "chain",
        label: "Share page",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.FOLDER],
        access: [FileAccess.ADMIN],
        permis: PERMS.medialibrary_share_page,
        action: ACT_VPORT.MODAL_SHAREPAGE,
    },
    {
        id: ActionId.ACCESS_FOLDER,
        area: [AREA.MYFILES, AREA.SHARED_WITH_ME],
        icon: "share",
        label: "Share",
        slcMode: SlcMode.LEAST_ONE,
        slcType: [FileType.MEDIA, FileType.FOLDER],
        access: [FileAccess.ADMIN],
        permis: null,
        action: ACT_VPORT.MODAL_ACCESS,
    },
    {
        id: ActionId.MOVE,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "drive_file_move_outline",
        label: "Move",
        slcMode: SlcMode.LEAST_ONE,
        slcType: [FileType.MEDIA, FileType.FOLDER],
        access: [FileAccess.ADMIN],
        permis: PERMS.medialibrary_manage_content,
        action: ACT_VPORT.MODAL_MOVE,
    },
    {
        id: ActionId.DELETE,
        area: [AREA.MYFILES, AREA.CORPORATE, AREA.PORTAL, AREA.SHARED_WITH_ME],
        icon: "delete",
        label: "Delete",
        slcMode: SlcMode.LEAST_ONE,
        slcType: [FileType.MEDIA, FileType.FOLDER],
        access: [FileAccess.ADMIN, FileAccess.WRITE],
        permis: PERMS.medialibrary_manage_content,
        action: ACT_VPORT.MODAL_DELETE,
    },
    {
        id: ActionId.DELETE_FOREVER,
        area: [AREA.TRASH_MYFILES, AREA.TRASH_CORPORATE, AREA.TRASH_PORTAL],
        icon: "delete_forever",
        label: "Delete Forever",
        slcMode: SlcMode.LEAST_ONE,
        slcType: [FileType.MEDIA, FileType.FOLDER],
        access: [],
        permis: null,
        action: ACT_VPORT.MODAL_DELETE_FOREVER,
    },
    {
        id: ActionId.DELETE_HRCH,
        area: [AREA.TRASH_PORTALS_LIST],
        icon: "delete",
        label: "Empty Bin",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.PORTAL],
        access: [FileAccess.ADMIN, FileAccess.WRITE],
        permis: null,
        action: ACT_VPORT.MODAL_DELETE_HIERARCHY,
    },
    {
        id: ActionId.RESTORE,
        area: [AREA.TRASH_MYFILES, AREA.TRASH_CORPORATE, AREA.TRASH_PORTAL],
        icon: "restore",
        label: "Restore",
        slcMode: SlcMode.SINGLE,
        slcType: [FileType.MEDIA, FileType.FOLDER],
        access: [],
        permis: null,
        action: ACT_VPORT.MODAL_RESTORE,
    },
];
export const getActions = ({ dispatchViewport, area, access, fileTypes, disabled, permissions, selection, }) => {
    return ACTIONS.filter((t) => {
        switch (t.slcMode) {
            case SlcMode.UNSELECT:
                return fileTypes.length === 0;
            case SlcMode.LEAST_ONE:
                return fileTypes.length >= 1;
            case SlcMode.SINGLE:
                return fileTypes.length === 1;
            case SlcMode.MASSIVE:
                return fileTypes.length > 1;
            default:
                return false;
        }
    })
        .filter((t) => {
        return !fileTypes.some((s) => !new Set(t.slcType).has(s));
    })
        .filter((t) => {
        if (isEmpty(t.permis))
            return true;
        return hasPerms([t.permis], permissions);
    })
        .filter((t) => {
        if (isEmpty(t.access))
            return true;
        return new Set(t.access).has(access);
    })
        .filter((t) => {
        if (isEmpty(t.area))
            return true;
        return new Set(t.area).has(area);
    })
        .filter((t) => {
        switch (t.id) {
            case ActionId.CREATE_FOLDER:
            case ActionId.UPLOAD_FOLDER:
            case ActionId.UPLOAD_MEDIA:
            case ActionId.MOVE:
                return !isPathMinusOne();
            case ActionId.RESTORE:
                return getPrnt() <= 0;
            default:
                return true;
        }
    })
        .map((t) => {
        return { ...t, disabled };
    })
        .map((t) => {
        var _a;
        switch (t.id) {
            case ActionId.UPLOAD_MEDIA:
                return {
                    ...t,
                    getAdditionalChildren: ({ onClose }) => (React.createElement(InputML, { onClose: onClose, directory: false, disabled: t.disabled })),
                };
            case ActionId.UPLOAD_FOLDER:
                return {
                    ...t,
                    getAdditionalChildren: ({ onClose }) => (React.createElement(InputML, { onClose: onClose, directory: true, disabled: t.disabled })),
                };
            case ActionId.DELETE_PORTAL:
                return {
                    ...t,
                    onClick: () => {
                        dispatchViewport({ type: t.action });
                    },
                    ...(isPortalConnectedToWebsite({
                        data: (_a = selection === null || selection === void 0 ? void 0 : selection[0]) === null || _a === void 0 ? void 0 : _a.data,
                    }) && {
                        disabled: true,
                        disabledTooltip: "This portal is connected to an external website.",
                        onClick: () => { },
                    }),
                };
            default:
                return {
                    ...t,
                    onClick: () => {
                        dispatchViewport({ type: t.action });
                    },
                };
        }
    });
};
